export default __webpack_public_path__ + "static/media/60t.ae8ba801.jpg";